import { isObject, mergeWith } from 'lodash-es';

/**
 * Returns a value as object.
 * If it is an object, it will be retured.
 * If it is any other type, it will be added under `defaultAttr` of a new object
 */
export function asObject(any: unknown, defaultAttr: string) {
    return isObject(any) ? any : { [defaultAttr]: any };
}

/**
 * Merges two objects and also sets `undefined` which the default `merge` lodash function doesn't do.
 */
export function mergeWithUndefined<T extends object, S extends object>(target: T, src: S): T & S {
    return mergeWith(target, src, (targetVal, srcVal, key, obj) => {
        if (srcVal === undefined) {
            // @ts-ignore params not properly typed by lodash
            // eslint-disable-next-line no-param-reassign
            obj[key] = undefined;
        }
    });
}
